module.exports = __webpack_public_path__ + "static/media/HTML-CSS-JS.ba6d0a84.png";